import axios from 'axios'
import { checkCognitoSession } from '../clients/userPool'

const downloadDashboardTips = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'GovDocs_Postings_Dashboard_Tip_Sheet')
  return downloadFileFromS3(url, 'GovDocs Dashboard Tip Sheet.pdf')
}

const downloadPostingsUserGuide = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'GovDocs_Postings_Dashboard_User_Guide')
  return downloadFileFromS3(url, 'GovDocs Postings Dashboard User Guide.pdf')
}

const downloadMinimumWageUserGuide = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'GovDocs_Minimum_Wage_User_Guide')
  return downloadFileFromS3(url, 'GovDocs Minimum Wage User Guide.pdf')
}

const openExemptSalaryThresholdRequirementsFile = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Exempt_Salary_Data')
  window.open(url)
}

const openPayTransparencyAndSalaryHistoryBanJurisdictions = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Pay_Transparency_and_Salary_History_Ban_Jurisdictions')
  window.open(url)
}

// aka indexed-rate-summary
const openIndexingJurisdictionsFile = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Minimum_Wage_Indexing_Jurisdictions')
  window.open(url)
}

const openCanadianMinWageDoc = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Canadian_Minimum_Wages')
  window.open(url)
}

const openFederalContractorPaidSickLeaveFile = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Federal_Contractor_Paid_Sick_Leave')
  window.open(url)
}

const openVotingLeaveRequirementsFile = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Voting_Leave_Requirements')
  window.open(url)
}

const openBereavementLeaveRequirementsFile = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Bereavement_Leave_Requirements')
  window.open(url)
}

const openFederalEmployeePaidParentalLeaveFile = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Federal_Employee_Paid_Parental_Leave')
  window.open(url)
}

const openJuryDutyLeaveRequirementsFile = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Jury_Duty_Leave_Requirements')
  window.open(url)
}
const openFederalFamilyAndMedicalLeaveAct = async () => {
  const url = await getPresignedUrlForPdf('application-static-resources', 'us-east-1', 'Federal_Family_and_Medical_Leave_Act')
  window.open(url)
}

export {
  // these download files
  downloadDashboardTips,
  downloadPostingsUserGuide,
  downloadMinimumWageUserGuide,
  // these open files in a new window
  openExemptSalaryThresholdRequirementsFile,
  openPayTransparencyAndSalaryHistoryBanJurisdictions,
  openIndexingJurisdictionsFile,
  openCanadianMinWageDoc,
  openFederalContractorPaidSickLeaveFile,
  openFederalEmployeePaidParentalLeaveFile,
  openVotingLeaveRequirementsFile,
  openBereavementLeaveRequirementsFile,
  openJuryDutyLeaveRequirementsFile,
  openFederalFamilyAndMedicalLeaveAct
}

export const getPresignedUrlForPdf = (s3bucket, bucketRegion, fileName) => {
  return apiAsync({
    api: 'external/platformService/presignedUrl',
    method: 'GET',
    params: {
      verb: 'get',
      region: bucketRegion,
      s3BucketName: s3bucket,
      fileName: `${fileName}.pdf`,
      fileType: 'pdf'
    }
  })
}

export const downloadFileFromS3 = async (url, fileName) => {
  // https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    credentials: 'same-origin',
    headers: { Accept: 'application/pdf' },
    redirect: 'follow',
    referrerPolicy: 'no-referrer'
  })

  const blob = await response.blob()
  const anchor = document.createElement('a')
  anchor.href = URL.createObjectURL(blob)
  anchor.setAttribute('download', fileName)
  anchor.click()
  anchor.remove()
}

// Note - this is a simplified version of the code in common/helpers.  It lives here to break a dependency cycle.
const apiAsync = async (options) => {
  const session = checkCognitoSession()
  const idToken = session ? session.getIdToken().getJwtToken() : null
  const headers = {}
  headers['Content-Type'] = 'application/json'
  headers.Authorization = `Bearer ${idToken}`

  const config = {
    baseURL: `${API_BASE_PATH}`,
    headers,
    url: options.api,
    method: 'GET',
    params: options.params,
    responseType: 'json',
    validateStatus: () => true,
    cancelToken: options.cancelToken
  }

  const response = await axios(config)
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Server error! Status Code', error.response.status)
        console.error('Error Data', error.response.data)
      } else {
        console.error('Error', error.message)
      }
      console.error(error.config)

      return {}
    })

  return response.data
}
